package com.ervasstudio.tracoemovimento.pages.cursos

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.pages.cursos.cursos.Cursos
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun CursosPage() {

    Cursos()
}